import { LOGO_URL } from "../data/site";

export default function Logo({ className = "h-12", dark = false, showText = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="gdf-logo">
      <img src={LOGO_URL} alt="Givers Driven Funds" className={`${className} w-auto object-contain`} />
      {showText && (
        <span className={`font-head font-extrabold text-lg ${dark ? "text-white" : "text-[#0A192F]"}`}>
          Givers Driven Funds
        </span>
      )}
    </div>
  );
}
